export default __webpack_public_path__ + "static/media/003.6f1bb14d.jpg";